const ActionType = {
  OPEN_BANNER_TELEGRAM_BOTTOM: 'OPEN_BANNER_TELEGRAM_BOTTOM',
  CLOSE_BANNER_TELEGRAM_BOTTOM: 'CLOSE_BANNER_TELEGRAM_BOTTOM',
}

export default ActionType
